#import "../fragments/lead-basic.graphql"
query GetLeadsSearchResults($query: String, $limit: Int) {
    search(query: $query, type: LEAD, limit: $limit) {
        quickResults {
            leadResults {
                ...LeadBasic
            }
        }
    }
}
